import script from "./GbDialogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./GbDialogs.vue?vue&type=script&setup=true&lang=ts"

import "./GbDialogs.vue?vue&type=style&index=0&id=219119b7&lang=less"

const __exports__ = script;

export default __exports__